// eslint-disable-next-line no-shadow
export enum Feature {
  DELAYED_ONLINE_STATUS = 'delayed_online_status',
}

export const features: ReadonlySet<Feature> = new Set([
  Feature.DELAYED_ONLINE_STATUS,
])
